import ajax from './ajax';

// Matches the backend category document shape
export interface Category {
    _id: string;
    name: string;
    slug?: string;
    description?: string;
    parentId?: string;
    icon?: string;
    color?: string;
    displayOrder?: number;
    level?: number;
    path?: string;
    isPublic?: boolean;
    status?: string;
    createdAt: string;
    updatedAt: string;
}

export interface CategoryTree extends Category {
    children?: CategoryTree[];
    questionCount?: number;
}

export interface CreateCategoryData {
    name: string;
    slug?: string;
    description?: string;
    parentId?: string;
    icon?: string;
    color?: string;
    displayOrder?: number;
}

export interface UpdateCategoryData extends Partial<CreateCategoryData> {
    status?: string;
    parentId?: string;
}

export interface CategoryListParams {
    page?: number;
    limit?: number;
    search?: string;
    parentId?: string;
    status?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface CategoryListResponse {
    categories: Category[];
    total: number;
    page: number;
    limit: number;
}

class CategoryService {
    async listCategories(params: CategoryListParams = {}): Promise<CategoryListResponse> {
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                queryParams.append(key, String(value));
            }
        });
        const query = queryParams.toString();
        return ajax.get(`/api/categories${query ? `?${query}` : ''}`);
    }

    async getCategoryById(id: string): Promise<Category> {
        return ajax.get(`/api/categories/${id}`);
    }

    async createCategory(data: CreateCategoryData): Promise<Category> {
        return ajax.post('/api/categories', data);
    }

    async updateCategory(id: string, data: UpdateCategoryData): Promise<Category> {
        return ajax.put(`/api/categories/${id}`, data);
    }

    async deleteCategory(id: string): Promise<{ message: string }> {
        return ajax.delete(`/api/categories/${id}`);
    }

    async getCategoryTree(): Promise<CategoryTree[]> {
        // Backend responds { tree: [...] }
        const response = await ajax.get('/api/categories/tree');
        return response?.tree || [];
    }
}

export default new CategoryService();
